import { useNavigate } from "react-router-dom";
import { getFlagSvgUrl } from "@/lib/country-flags";
import { getCountrySlugByCode } from "@/config/connect-countries";

interface Country {
  name: string;
  flag: string;
  code: string;
}

const popularCountries: Country[] = [
  { name: "South Sudan", flag: "🇸🇸", code: "SS" },
  { name: "Ethiopia", flag: "🇪🇹", code: "ET" },
  { name: "Nigeria", flag: "🇳🇬", code: "NG" },
  { name: "Kenya", flag: "🇰🇪", code: "KE" },
  { name: "Uganda", flag: "🇺🇬", code: "UG" },
  { name: "Somalia", flag: "🇸🇴", code: "SO" },
];

interface PopularCountryChipsProps {
  onSelect?: (country: Country) => void;
  className?: string;
}

export function PopularCountryChips({ onSelect, className }: PopularCountryChipsProps) {
  const navigate = useNavigate();

  const handleClick = (country: Country) => {
    if (onSelect) {
      onSelect(country);
    } else {
      // Navigate to country-specific landing page
      const slug = getCountrySlugByCode(country.code);
      navigate(`/connect-portal/${slug}`);
    }
  };

  return (
    <div className={`flex flex-wrap justify-center gap-2 ${className}`}>
      {popularCountries.map((country) => (
        <button
          key={country.code}
          onClick={() => handleClick(country)}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-muted hover:bg-primary/10 hover:text-primary transition-colors text-base font-medium"
        >
          <img 
            src={getFlagSvgUrl(country.flag)} 
            alt={country.name}
            className="w-5 h-4 object-cover rounded-sm"
          />
          <span>{country.name}</span>
        </button>
      ))}
    </div>
  );
}
